<div class="admin-deployments-container">
    <h2>List of all deployments()</h2>

    <div *ngIf="loading()">Loading health metrics...</div>

    <div *ngIf="!loading() && healthData()" class="health-summary-line">
        API access:
        <span class="health-status-wrapper">
            <span class="health-status-text" [ngClass]="healthData().status.toLowerCase()">
                {{ healthData().status }}
            </span>
            <div class="health-details-tooltip">
                <ul>
                    <li><strong>Status:</strong> {{ healthData().status }}</li>
                    <li><strong>Machine Name:</strong> {{ healthData().machineName }}</li>
                    <li><strong>OS:</strong> {{ healthData().os }}</li>
                    <li><strong>Framework:</strong> {{ healthData().framework }}</li>
                    <li><strong>CPU Count:</strong> {{ healthData().cpuCount }}</li>
                    <li><strong>Memory Usage:</strong> {{ healthData().memoryUsageMB }} MB</li>
                    <li><strong>Uptime:</strong> {{ healthData().uptime }}</li>
                    <li><strong>Timestamp (UTC):</strong> {{ healthData().timestamp }}</li>
                </ul>
            </div>
        </span>
    </div>

    <div class="deployment-table-container" *ngIf="deployments().length; else loadingOrEmpty">
        <table class="deployment-table">
            <thead>
                <tr>
                    <th>Serial #</th>
                    <th>Region</th>
                    <th>Status</th>
                    <th>Created</th>
                    <th>Deployment Type</th>
                    <th>Email</th>
                    <th>Version</th>
                    <th>Online Usage</th>
                    <th>Actions</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let deployment of deployments()">

                    <td *ngIf="(deployment.status === Status.COMPLETE
                    || deployment.status === Status.UPDATE_COMPLETED);
                            then anchored
                            else plain">
                    </td>
                    <ng-template #anchored>
                        <td>
                            <a class="external" target="_blank" rel="noopener noreferrer"
                                [href]="deployment.url.endsWith('.') ? deployment.url.stripLast() : deployment.url">{{
                                deployment.serialNumber }}</a>
                        </td>
                    </ng-template>
                    <ng-template #plain>
                        <td><span>{{ deployment.serialNumber }}</span></td>
                    </ng-template>

                    <td>{{ deployment.displayRegion }}</td>
                    <td>
                        <span class="status-badge" [ngClass]="deployment.status.toLowerCase()">
                            {{ deployment.status }}
                        </span>
                    </td>
                    <td>{{ deployment.created | date: 'medium' }}</td>
                    <td>{{ deployment.deploymentType?.toUpperCase() }}</td>
                    <td>{{ deployment.deploymentEmail }}</td>
                    <td>{{ deployment.version || 'N/A' }}</td>
                    <td>{{ (deployment.onlineSizeUsage / 1073741824) | number:'1.1-2' }} GB</td>
                    <td>
                        <a class="link-btn" [href]="deployment.url" target="_blank">SSM Super</a>
                    </td>
                </tr>
            </tbody>
        </table>
        <div class="load-more-container">
            <button class="load-more-btn" (click)="loadNextPage()" [disabled]="!lastKey() || loading()">Load
                More</button>
        </div>

        <div *ngIf="loading()" class="loading-spinner">
            Loading more deployments()...
        </div>

    </div>


    <ng-template #loadingOrEmpty>
        <div class="message-box">
            <ng-container *ngIf="loading()">Loading deployments()...</ng-container>
            <ng-container *ngIf="!loading() && !deployments().length">No deployments() found.</ng-container>
            <ng-container *ngIf="error()">
                <div *ngIf="error()">
                    <pre class="error-message">{{ error() }}</pre>
                </div>
            </ng-container>
        </div>
    </ng-template>


</div>
